import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Hammer from 'hammerjs';


class HomeLelang extends Component{
  componentDidMount() {

    var tinderContainer = document.querySelector('.t-slider-wrapper');
    var allCards = document.querySelectorAll('.t-slider-card');

    function initCards(card, index) {
      var newCards = document.querySelectorAll('.t-slider-card:not(.removed)');

      newCards.forEach(function (card, index) {
        if(index < 3){
          card.style.zIndex = allCards.length - index;
          card.style.transform = 'scale(' + (20 - index) / 20 + ') translateY(+' + 30 * index + 'px)';
          card.style.opacity = (10 - index) / 10;
        }
      });

      tinderContainer.classList.add('loaded');
    }

    initCards();

    allCards.forEach(function (el) {
      var hammertime = new Hammer(el);

      hammertime.on('pan', function (event) {
        el.classList.add('moving');
      });

      hammertime.on('pan', function (event) {
        if (event.deltaX === 0) return;
        if (event.center.x === 0 && event.center.y === 0) return;

        var xMulti = event.deltaX * 0.03;
        var yMulti = event.deltaY / 80;
        var rotate = xMulti * yMulti;

        el.style.transform = 'translate(' + event.deltaX + 'px, ' + event.deltaY + 'px) rotate(' + rotate + 'deg)';
      });

      hammertime.on('panend', function (event) {
        el.classList.remove('moving');

        var moveOutWidth = document.body.clientWidth;
        var keep = Math.abs(event.deltaX) < 80 || Math.abs(event.velocityX) < 0.5;

        el.classList.toggle('removed', !keep);

        if (keep) {
          el.style.transform = '';
        } else {
          var endX = Math.max(Math.abs(event.velocityX) * moveOutWidth, moveOutWidth);
          var toX = event.deltaX > 0 ? endX : -endX;
          var endY = Math.abs(event.velocityY) * moveOutWidth;
          var toY = event.deltaY > 0 ? endY : -endY;
          var xMulti = event.deltaX * 0.03;
          var yMulti = event.deltaY / 80;
          var rotate = xMulti * yMulti;

          el.style.transform = 'translate(' + toX + 'px, ' + (toY + event.deltaY) + 'px) rotate(' + rotate + 'deg)';
          initCards();
        }
      });
    });
  }

  render(){
    let children = [];
    this.props.data.items.forEach((item, number) => {
      children.push(
          <div key={'auc-' + number} className="t-slider-card">
            <div className="lelang-inner">
              <div className="lelang-title">{item.title}</div>
              <div className="lelang-img">
                <img src={item.image} />
              </div>
              <div className="lelang-last-bid">Tawaran terakhir</div>
              <div className="lelang-result">{item.last_bid}</div>
              <div className="lelang-input">
                <input type="text" className="form-control" placeholder="2550000" />
                <button className="btn btn-tawar">TAWAR</button>
              </div>
              <div className="lelang-note">*Minimal Rp {item.bid_increment} atau kelipatannya</div>
              <div className="lelang-detail">
                <div><img src="http://resources.triyakom.com/mini_portal/clock.svg" /><span>{item.time_left}</span></div>
                <div><img src="http://resources.triyakom.com/mini_portal/clock.svg" /><span>{item.bid_count} Tawaran</span></div>
              </div>
            </div>
          </div>
      );
    });
    return(
      <>
      <div className="home-lelang">
        <div className="container">
          <h2>Mau punya barang pribadinya {this.props.nick} ?</h2>
        </div>
        <div className="t-slider-wrapper">
          <div className="t-slider">
            {children}
          </div>
        </div>
      </div>
      </>
    );
  }
}

export default HomeLelang;
